import { getSupportedBrowserConfigs } from './getSupportedBrowserConfigs';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isPWA } from 'mini-device-utils/lib/utils/isPWA';
import { isPWAInstalled } from 'mini-device-utils/lib/utils/isPWAInstalled';
import { isUserBrowserSupportedForA2HSCampaign } from './isUserBrowserSupportedForA2HSCampaign';
import { isUserNewToMini } from 'mini-account-activity/lib/utils/isUserNewToMini';

export const shouldShowA2HSNudge = async (): Promise<boolean> => {
    const isPWAAlreadyInstalled = await isPWAInstalled();
    return (
        !isMiniHostAppFeatureEnabled('native') &&
        !isPWA() &&
        !isPWAAlreadyInstalled &&
        !isUserNewToMini(30) &&
        isUserBrowserSupportedForA2HSCampaign(getSupportedBrowserConfigs())
    );
};
